import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import BranchAccount from "../views/BranchAccount.vue";
import Login from "../views/Auth/Login.vue";
import Signup from "../views/Auth/Signup.vue";
import Operations from "../views/Operations.vue";
import AddProducts from "../views/AddProduct.vue";
import Orders from "../views/Orders/Index.vue";
import PenddingOrders from "../views/Orders/Pendding.vue";

import OrdersReport from "../views/Orders/Report.vue";
import OrdersStatistics from "../views/Orders/Statistics.vue";
import OrdersProducts from "../views/Orders/Products.vue";
import BranchesSales from "../views/Orders/BranchesSales.vue";
import Stores from "../views/Stores.vue";
import Register from "../views/Register.vue";

import Offers from "../views/offers/index.vue";
import AddOffer from "../views/offers/add.vue";
import UpdateOffer from "../views/offers/update.vue";

import OrdersRates from "@/views/OrdersRates.vue";

import ExpensesReport from "../views/Expenses/Report.vue";
import NewExpense from "../views/Expenses/New.vue";
import ExpenseDetails from "../views/Expenses/ReportDetails.vue";

import SafeReport from "../views/Safes/Report.vue";
import NewSafe from "../views/Safes/New.vue";

import UsersAccounts from "../views/Users-Accounts.vue";
import PromoCodes from "../views/PromoCodes.vue";

import Purchases from "../views/purchases";
import NewPurchase from "../views/purchases/New.vue";
import PurchasesReport from "../views/purchases/Report.vue";
import ReturnPurchases from "../views/purchases/Return.vue";
import ReturnPurchasesReport from "../views/purchases/ReturnReport.vue";
import MaterialIngredients from "../views/purchases/MaterialIngredients.vue";
import OPerations from "../views/purchases/Operations.vue";
import OperationsReport from "../views/purchases/OperationsReport.vue";
import MaterialMovement from "../views/purchases/MaterialMovement.vue";
import MaterialMovementReport from "../views/purchases/MaterialMovementReport.vue";
import SuppliersAccount from "../views/purchases/SuppliersAccount.vue";
import Tabs from "../views/purchases/Tabs.vue";

Vue.use(VueRouter);

const routes = [
 

  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },

  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      requiresAuth: true,
    },
  }


    ];
  


const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
